var $38c43f8322316031$exports = {};
$38c43f8322316031$exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " \u05E2\u05D3 ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " \u05E0\u05D1\u05D7\u05E8");
  },
  "finishRangeSelectionPrompt": "\u05D7\u05E5 \u05DB\u05D3\u05D9 \u05DC\u05E1\u05D9\u05D9\u05DD \u05D0\u05EA \u05D1\u05D7\u05D9\u05E8\u05EA \u05D8\u05D5\u05D5\u05D7 \u05D4\u05EA\u05D0\u05E8\u05D9\u05DB\u05D9\u05DD",
  "maximumDate": "\u05EA\u05D0\u05E8\u05D9\u05DA \u05E4\u05E0\u05D5\u05D9 \u05D0\u05D7\u05E8\u05D5\u05DF",
  "minimumDate": "\u05EA\u05D0\u05E8\u05D9\u05DA \u05E4\u05E0\u05D5\u05D9 \u05E8\u05D0\u05E9\u05D5\u05DF",
  "next": "\u05D4\u05D1\u05D0",
  "previous": "\u05D4\u05E7\u05D5\u05D3\u05DD",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "\u05EA\u05D0\u05E8\u05D9\u05DA \u05E0\u05D1\u05D7\u05E8: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "\u05D8\u05D5\u05D5\u05D7 \u05E0\u05D1\u05D7\u05E8: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "\u05DC\u05D7\u05E5 \u05DB\u05D3\u05D9 \u05DC\u05D4\u05EA\u05D7\u05D9\u05DC \u05D1\u05D1\u05D7\u05D9\u05E8\u05EA \u05D8\u05D5\u05D5\u05D7 \u05D4\u05EA\u05D0\u05E8\u05D9\u05DB\u05D9\u05DD",
  "todayDate": function todayDate(args) {
    return "\u05D4\u05D9\u05D5\u05DD, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "\u05D4\u05D9\u05D5\u05DD, ".concat(args.date, " \u05E0\u05D1\u05D7\u05E8");
  }
};
export { $38c43f8322316031$exports as default };